import { render, staticRenderFns } from "./RepairImages.vue?vue&type=template&id=38787ca7&scoped=true"
import script from "./RepairImages.vue?vue&type=script&lang=js"
export * from "./RepairImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38787ca7",
  null
  
)

export default component.exports